import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="xv-seccion" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="xv-titulo-eventos" />
        <div className="xv-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="xv-evento" data-testid={`xv-evento-${ev.id || i}`}>
                <p className="xv-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="xv-evento-nombre">{ev.lugar}</h3>
                <p className="xv-evento-hora">
                  <Clock strokeWidth={1.5} />
                  <span>{ev.horario}</span>
                </p>
                <p className="xv-evento-detalle">
                  <MapPin strokeWidth={1.5} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="xv-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`xv-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={1.5} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
